import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const VisualizarDadosVenda = ({ venda }) => {
  const getSituacao = (venda) => {
    switch (venda?.situacao) {
      case 'EM_ORCAMENTO':
        return 'Em orçamento';
      case 'VENDA_APROVADA':
        return 'Venda aprovada';
      case 'ORCAMENTO_RECUSADO':
        return 'Orçamento recusado';
      default:
        return '';
    }
  };

  const getMotivoVenda = (venda) => {
    switch (venda?.motivoVenda) {
      case 'VENDA_PADRAO':
        return 'Venda';
      case 'VENDA_ENTREGA_FUTURA':
        return 'Venda de entrega futura';
      case 'VENDA_A_ORDEM':
        return 'Venda à ordem';
      default:
        return '';
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <TextLabel
          id="identificador"
          label="Identificador"
          value={venda?.identificador ? `${venda?.identificador}`.padStart(3, '0') : '-'}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <DateLabel id="data" label="Data" value={venda?.data ? moment(venda?.data) : null} />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="situacao" label="Situação" value={getSituacao(venda)} />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="motivoVenda" label="Motivo da venda" value={getMotivoVenda(venda)} />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="cliente" label="Cliente" value={venda?.cliente?.pessoa?.nome} />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="vendedor" label="Vendedor" value={venda?.vendedor?.pessoa?.nome} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextLabel id="descricao" label="Descrição" value={venda?.descricao} />
      </Grid>
    </Grid>
  );
};

export default VisualizarDadosVenda;
